/*
 * Copyright (c) 2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import * as React from 'react';
import bind from 'apmui/decorators/bind';
import componentStyle from 'apmui/util/componentStyle';
import onKeyPress from 'apmui/util/onKeyPress';

interface IExpandableProps {
    caption: string;
    captionClassName?: string;
    className?: string;
    initialState: boolean;
}

interface IExpandableState {
    open: boolean;
}

declare module 'react' {
    /* eslint-disable @typescript-eslint/interface-name-prefix */
    interface HTMLAttributes<T> {
        open?: boolean;
    }
}

const C = componentStyle.bind(null, 'apmui-expandable');

class Expandable extends React.Component<IExpandableProps, IExpandableState> {
    static defaultProps = {
        initialState: false,
    };

    state = {
        open: this.props.initialState,
    };

    @bind
    onClick() {
        this.setState((state: IExpandableState) => ({ open: !state.open }));
    }

    render() {
        return (
            <div className={C('&', this.props.className)} open={this.state.open}>
                <div
                    className={C('&--caption', this.props.captionClassName)}
                    onClick={this.onClick}
                    onKeyPress={onKeyPress(this.onClick)}
                    role="button"
                    tabIndex={0}>
                    {this.props.caption}
                </div>
                {this.props.children}
            </div>
        );
    }
}

export default Expandable;
